import React from 'react';
import { RuDiagramModal } from './RuDiagramModal';

export const RuHeightModal = RuDiagramModal({
  title: 'Water Height (meters)',
  content: (
    <div>
      {' '}
      <p>
        The maximum water height above sea level in meters.
        {' '}
        <i>See image and text below for more information.</i>
        {' '}
        If the type of measurement is:
      </p>
    </div>
  ),
});
